import { PackageOpen } from 'lucide-react';
import { Surface, Typography } from '@kustom-checkout/morpheus';
import ShippingModule, {
  type ShippingLocale,
} from '@kustom-checkout/shipping';

interface ShippingModulePanelProps {
  clientToken?: string;
  locale?: string;
  orderId?: string;
}

export function ShippingModulePanel({
  clientToken,
  locale,
  orderId,
}: ShippingModulePanelProps) {
  if (!clientToken) {
    return (
      <Surface
        color="weak"
        borderColor="subtle"
        className="flex flex-col items-center gap-3 py-12 text-center"
      >
        <PackageOpen
          className="text-on-surface-muted size-8"
          strokeWidth={1.5}
          aria-hidden
        />
        <Typography variant="h4">No shipping session yet</Typography>
        <Typography variant="small" color="muted" isMultiline>
          Fill in the TMS configuration on the left, then choose{' '}
          <strong>Load visual test</strong> to render the shipping module here.
        </Typography>
      </Surface>
    );
  }

  return (
    // The module's loading overlay is `absolute inset-0`, so it needs a
    // positioned ancestor. Without one it escapes to the viewport and covers
    // the whole page while a session loads.
    <div className="relative">
      <ShippingModule
        clientToken={clientToken}
        locale={locale as ShippingLocale}
        // Typed optional, but the module's analytics tracker uses orderId as
        // its session id and throws without one, so the module never renders.
        orderId={orderId}
        onChange={console.info}
      />
    </div>
  );
}
